/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "af": {
        "nu": ["latn"],
        "year": {
          "0": "hierdie jaar",
          "1": "volgende jaar",
          "future": {
            "one": "oor {0} jaar",
            "other": "oor {0} jaar"
          },
          "past": {
            "one": "{0} jaar gelede",
            "other": "{0} jaar gelede"
          },
          "-1": "verlede jaar"
        },
        "year-short": {
          "0": "hierdie j.",
          "1": "volgende j.",
          "future": {
            "one": "oor {0} j.",
            "other": "oor {0} j."
          },
          "past": {
            "one": "{0} j. gelede",
            "other": "{0} j. gelede"
          },
          "-1": "verlede j."
        },
        "year-narrow": {
          "0": "hierdie j.",
          "1": "volgende j.",
          "future": {
            "one": "oor {0} j.",
            "other": "oor {0} j."
          },
          "past": {
            "one": "{0} j. gelede",
            "other": "{0} j. gelede"
          },
          "-1": "verlede j."
        },
        "quarter": {
          "0": "hierdie kwartaal",
          "1": "volgende kwartaal",
          "future": {
            "one": "oor {0} kwartaal",
            "other": "oor {0} kwartale"
          },
          "past": {
            "one": "{0} kwartaal gelede",
            "other": "{0} kwartale gelede"
          },
          "-1": "verlede kwartaal"
        },
        "quarter-short": {
          "0": "hierdie kwartaal",
          "1": "volgende kwartaal",
          "future": {
            "one": "oor {0} kw.",
            "other": "oor {0} kw."
          },
          "past": {
            "one": "{0} kw. gelede",
            "other": "{0} kw. gelede"
          },
          "-1": "verlede kwartaal"
        },
        "quarter-narrow": {
          "0": "hierdie kwartaal",
          "1": "volgende kwartaal",
          "future": {
            "one": "oor {0} kw.",
            "other": "oor {0} kw."
          },
          "past": {
            "one": "{0} kw. gelede",
            "other": "{0} kw. gelede"
          },
          "-1": "verlede kwartaal"
        },
        "month": {
          "0": "vandeesmaand",
          "1": "volgende maand",
          "future": {
            "one": "oor {0} maand",
            "other": "oor {0} maande"
          },
          "past": {
            "one": "{0} maand gelede",
            "other": "{0} maande gelede"
          },
          "-1": "verlede maand"
        },
        "month-short": {
          "0": "hierdie md.",
          "1": "volgende md.",
          "future": {
            "one": "oor {0} md.",
            "other": "oor {0} md."
          },
          "past": {
            "one": "{0} md. gelede",
            "other": "{0} md. gelede"
          },
          "-1": "verlede md."
        },
        "month-narrow": {
          "0": "hierdie md.",
          "1": "volgende md.",
          "future": {
            "one": "oor {0} md.",
            "other": "oor {0} md."
          },
          "past": {
            "one": "{0} md. gelede",
            "other": "{0} md. gelede"
          },
          "-1": "verlede md."
        },
        "week": {
          "0": "hierdie week",
          "1": "volgende week",
          "future": {
            "one": "oor {0} week",
            "other": "oor {0} weke"
          },
          "past": {
            "one": "{0} week gelede",
            "other": "{0} weke gelede"
          },
          "-1": "verlede week"
        },
        "week-short": {
          "0": "hierdie w.",
          "1": "volgende w.",
          "future": {
            "one": "oor {0} w.",
            "other": "oor {0} w."
          },
          "past": {
            "one": "{0} w. gelede",
            "other": "{0} w. gelede"
          },
          "-1": "verlede w."
        },
        "week-narrow": {
          "0": "hierdie w.",
          "1": "volgende w.",
          "future": {
            "one": "oor {0} w.",
            "other": "oor {0} w."
          },
          "past": {
            "one": "{0} w. gelede",
            "other": "{0} w. gelede"
          },
          "-1": "verlede w."
        },
        "day": {
          "0": "vandag",
          "1": "môre",
          "2": "oormôre",
          "future": {
            "one": "oor {0} dag",
            "other": "oor {0} dae"
          },
          "past": {
            "one": "{0} dag gelede",
            "other": "{0} dae gelede"
          },
          "-2": "eergister",
          "-1": "gister"
        },
        "day-short": {
          "0": "vandag",
          "1": "môre",
          "2": "oormôre",
          "future": {
            "one": "oor {0} dag",
            "other": "oor {0} dae"
          },
          "past": {
            "one": "{0} dag gelede",
            "other": "{0} dae gelede"
          },
          "-2": "eergister",
          "-1": "gister"
        },
        "day-narrow": {
          "0": "vandag",
          "1": "môre",
          "2": "oormôre",
          "future": {
            "one": "oor {0} dag",
            "other": "oor {0} dae"
          },
          "past": {
            "one": "{0} dag gelede",
            "other": "{0} dae gelede"
          },
          "-2": "eergister",
          "-1": "gister"
        },
        "hour": {
          "0": "hierdie uur",
          "future": {
            "one": "oor {0} uur",
            "other": "oor {0} uur"
          },
          "past": {
            "one": "{0} uur gelede",
            "other": "{0} uur gelede"
          }
        },
        "hour-short": {
          "0": "hierdie uur",
          "future": {
            "one": "oor {0} u.",
            "other": "oor {0} u."
          },
          "past": {
            "one": "{0} u. gelede",
            "other": "{0} u. gelede"
          }
        },
        "hour-narrow": {
          "0": "hierdie uur",
          "future": {
            "one": "oor {0} u.",
            "other": "oor {0} u."
          },
          "past": {
            "one": "{0} u. gelede",
            "other": "{0} u. gelede"
          }
        },
        "minute": {
          "0": "hierdie minuut",
          "future": {
            "one": "oor {0} minuut",
            "other": "oor {0} minute"
          },
          "past": {
            "one": "{0} minuut gelede",
            "other": "{0} minute gelede"
          }
        },
        "minute-short": {
          "0": "hierdie minuut",
          "future": {
            "one": "oor {0} min.",
            "other": "oor {0} min."
          },
          "past": {
            "one": "{0} min. gelede",
            "other": "{0} min. gelede"
          }
        },
        "minute-narrow": {
          "0": "hierdie minuut",
          "future": {
            "one": "oor {0} min.",
            "other": "oor {0} min."
          },
          "past": {
            "one": "{0} min. gelede",
            "other": "{0} min. gelede"
          }
        },
        "second": {
          "0": "nou",
          "future": {
            "one": "oor {0} sekonde",
            "other": "oor {0} sekondes"
          },
          "past": {
            "one": "{0} sekonde gelede",
            "other": "{0} sekondes gelede"
          }
        },
        "second-short": {
          "0": "nou",
          "future": {
            "one": "oor {0} s.",
            "other": "oor {0} s."
          },
          "past": {
            "one": "{0} s. gelede",
            "other": "{0} s. gelede"
          }
        },
        "second-narrow": {
          "0": "nou",
          "future": {
            "one": "oor {0} s.",
            "other": "oor {0} s."
          },
          "past": {
            "one": "{0} s. gelede",
            "other": "{0} s. gelede"
          }
        }
      }
    },
    "availableLocales": ["af-NA", "af"],
    "aliases": {},
    "parentLocales": {}
  });
}